import { useDispatch } from 'react-redux'
import { sliceNewRewardsCount } from '@/features/raundSlice'
import { raundUrl } from '@/lib/custom'
import { apiGet } from '@/lib/originalFetchApi'

export const usePresentCount = () => {
  const dispatch = useDispatch()
  const setPresentCount = async () => {
    const presentsCheckResBody: Api.PresentsCheckResBody = await apiGet(`${raundUrl.presents}/check/`)
    if (presentsCheckResBody) {
      const presentsCount = presentsCheckResBody.count
      dispatch(sliceNewRewardsCount(presentsCount))
    }
  }
  return { setPresentCount }
}
